import { isSameDomain, extractHostname, isClickLink } from './url';

export const addExternalAttributesIfNeeded = (url, siteUrl) => {
  if (!isSameDomain(url, extractHostname(siteUrl), true) || isClickLink(url)) {
    return { rel: 'external', target: '_blank', title: 'Opens in new window' };
  }

  return {};
};
